import './AccessCode.css';

import { useTranslation } from 'react-i18next';

import { Alert } from '../../shared/components/alert/Alert';
import { Button } from '../../shared/components/button/Button';
import { RightPanelContainer } from '../layout/RightPanelContainer';
import { useAccessCode } from './useAccessCode';

export function AccessCode() {
  const { t } = useTranslation();
  const { codeValue, errorMessage, isLoading, inputRef, setCodeValueHandler, codeSubmitHandler } =
    useAccessCode();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (isLoading) return;
    e.preventDefault();
    codeSubmitHandler();
  };

  return (
    <RightPanelContainer type="accessCode">
      <form onSubmit={handleSubmit}>
        <h1>{t('R008')}</h1>
        <p>{t('R009')}</p>
        <label className="not_logged_label" htmlFor="company_code">
          {errorMessage ? `${t('error.prefix')} ${t('R092')}` : t('R092')}
        </label>
        <input
          ref={inputRef}
          type="text"
          id="company_code"
          name="company_code"
          data-testid="access-code-input"
          className="code_input"
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessage ? 'access-code-error' : undefined}
          onChange={setCodeValueHandler}
          value={codeValue || ''}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isLoading) {
              e.preventDefault();
              codeSubmitHandler();
            }
          }}
        />
        {errorMessage && (
          <Alert
            type="error"
            message={errorMessage}
            id="access-code-error"
            dataTestId="access-code-error"
            isVisible
            isAssessive
          />
        )}
        <Button type="submit" dataTestId="access-code-submit">
          {t('R078')}
        </Button>
      </form>
    </RightPanelContainer>
  );
}
